import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LanguageSwitcherComponent} from './language-switcher.component';
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    LanguageSwitcherComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ]
})
export class LanguageSwitcherModule {
}
